module.exports = __webpack_public_path__ + "static/media/component5.449e8b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/component5.png
// module id = 2409
// module chunks = 0